import api from 'api'

export type DeleteTimeClockParams = {
  timeClockId: number
}

export async function deleteTimeClock({
  timeClockId,
}: DeleteTimeClockParams): Promise<void> {
  await api.delete(`/admin/time_clock/${timeClockId}`)
}
